import { r4Client, r4Error, DmsDatasourceApi, SqlDatasourceApi } from '@/services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('DatasourceStore')

const datasourceParams = payload => {
  return payload
}

const DatasourceStore = {
  namespaced: true,
  state: {
    datasources: [],
    datasource: {}
  },
  mutations: {
    saveDatasources: (state, payload) => (state.datasources = payload.data),
    saveDatasource: (state, payload) => {
      // handle cases were coming from API (.data) and from setting directly from list
      if (!payload) {
        state.datasource = {}
      } else if (payload.data) {
        state.datasource = payload.data
      } else {
        state.datasource = payload || {}
      }
    },
    resetDatasource: state => {
      state.datasource = {}
    }
  },
  actions: {
    fetchDatasources ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/datasources', { params: payload })
          .then(response => {
            commit('saveDatasources', response.data)
            resolve(state.datasources)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    fetchDmsDatasources ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/dms_datasources', { params: payload })
          .then(response => {
            commit('saveDatasources', response.data)
            resolve(state.datasources)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    fetchDmsDatasourceTemplates ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        DmsDatasourceApi.fetchDmsDatasourceTemplates(payload)
          .then(dsTemplates => {
            commit('saveDatasources', dsTemplates)
            resolve(state.datasources)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchCsvDatasources ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/csv_datasources', { params: payload })
          .then(response => {
            commit('saveDatasources', response.data)
            resolve(state.datasources)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    fetchSqlDatasources ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        SqlDatasourceApi.fetchSqlDatasources(payload)
          .then(sqlDatasources => {
            commit('saveDatasources', sqlDatasources.data)
            resolve(state.datasources)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    getDatasource ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get(`/api/v1/datasources/${payload.id}`)
          .then(response => {
            commit('saveDatasource', response.data)
            resolve(state.datasource)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    createCsvDatasource ({ state, commit }, payload) {
      const datasourceData = datasourceParams(payload)
      return new Promise((resolve, reject) => {
        r4Client().post('/api/v1/csv_datasources', datasourceData)
          .then(response => {
            logger.trace('Successfully created csv datasource')
            commit('saveDatasource', response.data)
            resolve(state.datasource)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    deleteDatasource ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        r4Client().delete(`/api/v1/datasources/${payload.id}`, payload)
          .then(() => {
            logger.trace('Successfully deleted datasource')
            resolve('ok')
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    }
  },
  getters: {
  }

}

export default DatasourceStore
